module.exports = __webpack_public_path__ + "img/mock-pic2.c987c1d0.png";